<app-modal #loginModal [fixedHeight]="true" [title]="getString('logIntoYourAccount')">
  <app-login *ngIf="loginModal.isOpen" (loginSuccess)="onLoginSuccess()"
  (onResetPassword)="resetPasswordClicked()"
  (onRegisterClick)="switchLoginToRegister()"></app-login>
</app-modal>

<app-modal #registerModal [fixedHeight]="true" [title]="getString('createYourCheapChartsAccount')"
  (onClose)="registerModalContent = 'registerChoice'">

  <app-register-choice *ngIf="registerModalContent == 'registerChoice' && registerModal.isOpen"
    (onRegisterNow)="registerModalContent = 'register'" (facebookConnected)="connectedWithFacebook($event)"
    (loginClicked)="switchToLogin()">
  </app-register-choice>

  <app-register *ngIf="registerModalContent == 'register' && registerModal.isOpen" [referralCode]="inviteCode"
    (onRegisterSuccess)="registerModalContent = 'registerSuccess'">
  </app-register>

  <app-register-username *ngIf="registerModalContent == 'registerUsername' && registerModal.isOpen"
    [facebookResponse]="facebookResponse" [referralCode]="inviteCode"
    (onRegisterSuccess)="registerModalContent = 'registerSuccess'">
  </app-register-username>

  <app-register-success *ngIf="registerModalContent == 'registerSuccess' && registerModal.isOpen"
    (onLoginClick)="loginClickedFromRegisterSuccess()"></app-register-success>

</app-modal>

<app-modal #resetPasswordModal [title]="getString('resetPassword')">
  <app-reset-password *ngIf="resetPasswordModal.isOpen" #resetPasswordComponent (onOk)="resetPasswordModal.close()"></app-reset-password>
</app-modal>
